import CancelRental from '@/components/edit-reservation/cancel-rental';

export default CancelRental;
